module["exports"] = [];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/name/prefix.js
// module id = 1420
// module chunks = 1